import { render, staticRenderFns } from "./intentionOrder.vue?vue&type=template&id=688900fc&scoped=true"
import script from "./intentionOrder.vue?vue&type=script&lang=js"
export * from "./intentionOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688900fc",
  null
  
)

export default component.exports